let Constants = {
	PROMO_CODE: "663",
	CH_PROMO: "CH_663_MLB_WEB_BIGCARRE22_CRS_CAR_20220127_20220505",
	API_PROMOCODE: "carrefour-2022"
}
export default Constants;
